import { type FC } from 'react';

const VersionTimelineMock: FC = () => (
  <div className="rounded-lg border border-gray-200/80 overflow-hidden shadow-lg shadow-black/10" style={{ background: '#181825' }}>
    {/* Explorer header */}
    <div className="flex items-center justify-between px-3 py-2 border-b border-white/[0.06]">
      <span className="text-[10px] uppercase tracking-widest text-gray-500">Explorer</span>
    </div>

    {/* History section header */}
    <div className="px-3 pt-3 pb-1">
      <div className="flex items-center gap-1.5">
        <svg className="w-2.5 h-2.5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M9 5l7 7-7 7" /></svg>
        <svg className="w-3 h-3 text-[#9d4edd]/70" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        <span className="text-[11px] font-semibold text-gray-300 tracking-wide">History</span>
        <span className="text-[10px] text-gray-600 ml-0.5">v4</span>
      </div>
    </div>

    {/* Version items */}
    <div className="px-3 pb-4 pt-2">
      {[
        { ver: 1, msg: 'Initial strategy', time: '17d ago', experiments: 3, current: false },
        { ver: 2, msg: 'Adjusted EMA bounds', time: '14d ago', experiments: 5, current: false },
        { ver: 3, msg: 'Added RSI filter', time: '12d ago', experiments: 8, current: false },
        { ver: 4, msg: 'Parameter refinement', time: '10d ago', experiments: 12, current: true },
      ].map((v) => (
        <div
          key={v.ver}
          className={`relative pl-6 pr-2 py-2.5 ml-3 border-l-2 ${v.current
            ? 'border-[#9d4edd]/70 bg-[#9d4edd]/10'
            : 'border-gray-600/50'
            }`}
        >
          {/* Timeline node */}
          <div
            className={`absolute left-[-6px] top-3.5 w-2.5 h-2.5 rounded-full ring-2 ring-[#181825] ${v.current ? 'bg-[#9d4edd]' : 'bg-gray-500'
              }`}
          />

          {/* Version header */}
          <div className="flex items-center gap-2">
            <span className="w-3" />
            <span className={`text-[10px] font-medium ${v.current ? 'text-[#aa48ff]' : 'text-gray-500'}`}>
              v{v.ver}
            </span>
            {v.current && (
              <span className="text-[9px] px-1.5 py-0.5 bg-[#9d4edd]/20 text-[#aa48ff] rounded font-medium">
                Current
              </span>
            )}
          </div>

          {/* Message */}
          <p className="text-[9px] text-gray-600 mt-0.5 pl-3 leading-snug">{v.msg}</p>

          {/* Time */}
          <div className="flex items-center gap-1 mt-1 text-[9px] text-gray-600 pl-3">
            <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>{v.time}</span>
          </div>

          {/* Experiment count */}
          <div className="mt-1.5 pl-3 text-[10px] text-gray-500">
            <span className="flex items-center gap-1">
              <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714a2.25 2.25 0 00.659 1.591L19 14.5M14.25 3.104c.251.023.501.05.75.082M19 14.5l-2.47 5.527a.5.5 0 01-.46.298h-8.14a.5.5 0 01-.46-.298L5 14.5m14 0H5" /></svg>
              {v.experiments} experiments
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default VersionTimelineMock;
